// extracted by mini-css-extract-plugin
module.exports = {"instagramWrapper":"Rd-z","innerTile":"Sd-z","heading":"Td-z","instaTileBtn":"Ud-z","disabled":"Vd-z","instaTileElement":"Wd-z","instagramPic":"Xd-z"};